export default __webpack_public_path__ + "static/media/historyBlack.00b9488d.svg";